import React from 'react'
import { Form, Steps } from 'antd'
import { StyledAlert } from 'components'
import {
	StyledPreLoginForm,
	PreLoginView,
	PreLoginTitle,
	PreLoginSubTitle,
	PreLoginViewFooter
} from 'views/PreLogin/styled'
import useAxios from 'axios-hooks'
import { UtesterLogo, User1stLogo } from '../Logos';
import CreateAccountFrame from './Iframe'

function CreateAccount({ form }) {
	return (
		<PreLoginView>
			<StyledPreLoginForm>
				<UtesterLogo />
				<PreLoginTitle>Create Account</PreLoginTitle>
				<PreLoginSubTitle>Let's get started</PreLoginSubTitle>
                <CreateAccountFrame />
				<PreLoginViewFooter>
					<p>
						Already have an account? <a href="/sign-in">Sign-in</a>
					</p>
				</PreLoginViewFooter>
			</StyledPreLoginForm>
			<User1stLogo />
		</PreLoginView>
	)
}

export default CreateAccount;
